import * as React from "react";
import {
    Button,
    createStyles,
    Grid,
    TextField,
    Theme,
    withStyles,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@material-ui/core";
import { API } from "aws-amplify";
import {LoadingSpinner} from "../../../utils/LoadingSpinner";

const styles = ({ spacing }: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            marginLeft: spacing(16),
            marginRight: spacing(16),
        },
        formControl: {
            margin: spacing(1),
            minWidth: 200,
        },
        textField: {
            margin: spacing(1),
            width: "100%",
        },
        successMessage: {
            padding: spacing(2),
            marginTop: spacing(2),
            fontSize: '16px'
        }
    });

enum HubsProgram {
    ASSEMBIA = "ASSEMBIA",
    ASSISTRX = "ASSISTRX",
    EVERSANA = "EVERSANA"
}

interface IGetHubsOrderState {
    program: HubsProgram | '';
    partnerOrderId: string;
    formSubmitted: boolean;
    resultSuccessful: boolean;
    response: string;
}

class GetHubsOrderSection extends React.Component<any, IGetHubsOrderState> {
    constructor(props: any) {
        super(props);
        this.state = {
            program: '',
            partnerOrderId: '',
            formSubmitted: false,
            resultSuccessful: false,
            response: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    private handleValidation(): boolean {
        if (!this.state.program) {
            alert("Please select a program");
            return false;
        }
        if (!this.state.partnerOrderId) {
            alert("Please enter the Partner Order ID");
            return false;
        }
        return true;
    }

    private handleSubmit() {
        if (this.handleValidation()) {
            this.setState({ formSubmitted: true });

            const apiName = "ApaqPortalAPI";
            const path = "/hubs/order/get";
            const config = {
                queryStringParameters: {
                    program: this.state.program,
                    partnerOrderId: this.state.partnerOrderId
                },
                headers: {}
            };

            API.get(apiName, path, config)
                .then((response) => {
                    console.log("Success response:", response);
                    this.setState({
                        resultSuccessful: true,
                        formSubmitted: false,
                        response: JSON.stringify(response, null, 2)
                    });
                })
                .catch((error) => {
                    console.error("Error details:", error);
                    this.setState({
                        formSubmitted: false,
                        resultSuccessful: false
                    });
                    alert(`Error getting order: ${error.response?.data?.message || error.message || "Unknown error"}`);
                });
        }
    }

    public render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <h1>Get HUBS Order</h1>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Program *</InputLabel>
                            <Select
                                value={this.state.program}
                                onChange={(e) => this.setState({ program: e.target.value as HubsProgram })}
                                required
                            >
                                {Object.values(HubsProgram).map((prog) => (
                                    <MenuItem key={prog} value={prog}>
                                        {prog}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Partner Order ID *"
                            value={this.state.partnerOrderId}
                            onChange={(e) => this.setState({ partnerOrderId: e.target.value })}
                            variant="outlined"
                            className={classes.textField}
                            required
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            variant="outlined"
                            color="default"
                            onClick={this.handleSubmit}
                        >
                            Get Order
                        </Button>
                    </Grid>

                    {this.state.formSubmitted && (
                        <Grid item xs={12}>
                            <LoadingSpinner />
                        </Grid>
                    )}

                    {this.state.resultSuccessful && this.state.response && (
                        <Grid item xs={12}>
                            <TextField
                                label="Response"
                                multiline
                                rows={20}
                                value={this.state.response}
                                variant="outlined"
                                className={classes.textField}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(GetHubsOrderSection);
